import { useState, useEffect } from 'react';
import { getIndicatorsForCategory, getCategoryStats } from '../services/dataService';

/**
 * Hook to load indicators for a specific category from the manifest
 * @param {string} categoryId - The category ID (e.g., 'health', 'education')
 * @returns {{indicators: string[], loading: boolean, error: Error|null}}
 */
export const useCategoryIndicators = (categoryId) => {
  const [indicators, setIndicators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!categoryId) {
      setIndicators([]);
      setLoading(false);
      return;
    }

    let mounted = true;
    setLoading(true);
    setError(null);

    getIndicatorsForCategory(categoryId)
      .then(data => {
        if (mounted) {
          setIndicators(data);
          setLoading(false);
        }
      })
      .catch(err => {
        if (mounted) {
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, [categoryId]);

  return { indicators, loading, error };
};

/**
 * Hook to load category statistics (indicator counts) from the manifest
 * @returns {{stats: Array, loading: boolean, error: Error|null}}
 */
export const useCategoryStats = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    getCategoryStats()
      .then(data => {
        if (mounted) {
          setStats(data);
          setLoading(false);
        }
      })
      .catch(err => {
        if (mounted) {
          setError(err);
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  return { stats, loading, error };
};
